import axios from 'axios'

const instance = axios.create({
  baseURL: import.meta.env.VITE_SERVERAPI_URL || '',
})

instance.interceptors.request.use((config) => {
  if (window.catalog_config?.catalog_api_key) {
    config.headers['X-Api-Key'] = window.catalog_config.catalog_api_key
  }
  return config
})

export default instance
